<template>
  <OfficeLayout>
    <SpaceSettingsNav/>
    <transition name="router-anim">
      <router-view v-if="!current_space.dirty"></router-view>
    </transition>
  </OfficeLayout>
</template>

<script>
import {mapState} from "vuex";
import OfficeLayout from "@/components/layouts/cabinet/OfficeLayout";
import SpaceSettingsNav from "@/components/cabinet/SpaceSettings/SpaceSettingsNav";

export default {
  name: "TheAccountingSettings",
  components: {
    SpaceSettingsNav,
    OfficeLayout,
  },
  computed: {
    ...mapState('space', ['current_space'])
  }
}
</script>
